import {
  Box,
  IconButton,
  Modal,
} from "@mui/material"
import {
  NoPhotographyRounded,
  CloseRounded,
} from "@mui/icons-material"
import { makeStyles } from "@mui/styles"
import { PropertyArea } from "./propertyArea"
import { useState } from "react"
import {
  useTheme,
  styles,
  stylesDark,
  Styles
} from "../providers/theme"
import {
  SparePart,
  useSpareParts
} from "../providers/spareParts"

const useStylesLight = makeStyles<any, Styles>({...styles})
const useStylesDark = makeStyles<any, Styles>({...stylesDark})

export default function ShopItemCard({
  sparePart,
  currencyIcons
}: {
  sparePart: SparePart,
  currencyIcons: Record<string, string>
}) {
  const {selectedItem, setSelectedItem } = useSpareParts()
  const [isValidImage, setIsValidImage] = useState(true);

  const {mode} = useTheme()
  const classesLight = useStylesLight(styles)
  const classesDark = useStylesDark(stylesDark)
  const classes = mode === 'light' ? classesLight : classesDark

  return (
    <>
      <Modal
        open={selectedItem !== null}
        onClose={() => {
          setSelectedItem(null)
        }}
      >
        <Box
          className={classes.modalContainer}
          sx={{
            flexDirection: "column",
            padding: "2.5em 1.025em 1.5em 1.5em !important"
          }}
        >
          <Box
            className={classes.modalScrollableContainer}
            sx={{
              flexDirection: "column",
              padding: ".5em",
              margin: ""
            }}
          >
            <IconButton
              className={classes.modalButtonClose}
              onClick={() => {
                setSelectedItem(null)
              }}
            >
              <CloseRounded />
            </IconButton>
            <Box sx={{ width: "100%", height: "auto", margin: "0", display: "flex", justifyContent: "center" }}>
              <Box className={classes.shopItemPhotoContainer}>
                {
                  !!selectedItem!.Picture ?
                    isValidImage ? (
                      <img
                        referrerPolicy="no-referrer"
                        className={classes.userPhoto}
                        src={selectedItem?.Picture}
                        alt={selectedItem?.Description !== '' ? selectedItem?.Description : "Unknown"}
                        onError={(e) => {
                          setIsValidImage(false);
                        }}
                      />
                    ) : (
                      <NoPhotographyRounded fontSize="large" />
                    )
                  :
                    "loading"
                }
              </Box>
            </Box>
            <PropertyArea
              property={"Part number"}
              content={`${selectedItem?.Item || ""}`}
              classes={{
                container: classes['propertyArea'],
                property: `${classes['propertyAreaProperty']} ${classes['noOverflow']}`,
                content: `${classes['propertyAreaContent']} ${classes['noOverflow']}`
              }}
            />
             <PropertyArea
              property={"Description"}
              content={`${selectedItem?.Description || ""}`}
              classes={{
                container: `${classes['propertyArea']} ${classes['propertyAreaSmallTopMargin']}`,
                property: `${classes['propertyAreaProperty']} ${classes['noOverflow']}`,
                content: `${classes['propertyAreaContent']} ${classes['noOverflow']}`
              }}
            />
            <PropertyArea
              property={"Specification"}
              content={`${selectedItem?.Specification || ""}`}
              classes={{
                container: `${classes['propertyArea']} ${classes['propertyAreaSmallTopMargin']}`,
                property: `${classes['propertyAreaProperty']} ${classes['noOverflow']}`,
                content: `${classes['propertyAreaContent']} ${classes['noOverflow']}`
              }}
            />
            <PropertyArea
              property={"Price"}
              content={(selectedItem?.Price.toString() || "") + currencyIcons[sparePart.Currency] || ""}
              classes={{
                container: `${classes['propertyArea']} ${classes['propertyAreaSmallTopMargin']}`,
                property: `${classes['propertyAreaProperty']} ${classes['noOverflow']}`,
                content: `${classes['propertyAreaContent']} ${classes['noOverflow']}`
              }}
            />
            <PropertyArea
              property={"Discounted Price"}
              content={(selectedItem?.DiscountedPrice.toString() || "") + currencyIcons[sparePart.Currency] || ""}
              classes={{
                container: `${classes['propertyArea']} ${classes['propertyAreaSmallTopMargin']}`,
                property: `${classes['propertyAreaProperty']} ${classes['noOverflow']}`,
                content: `${classes['propertyAreaContent']} ${classes['noOverflow']}`
              }}
            />
            <PropertyArea
              property={"Stock state"}
              content={
                (() => {
                  if (selectedItem?.State.toLowerCase() === "red") return "Out of Stock";
                  if (selectedItem?.State.toLowerCase() === "green") return "In Stock";
                  if (selectedItem?.State.toLowerCase() === "yellow") return "Low Stock";
                  return "Out of Stock";
                })()
              }
              classes={{
                container: `${classes['propertyArea']} ${classes['propertyAreaSmallTopMargin']}`,
                property: `${classes['propertyAreaProperty']} ${classes['noOverflow']}`,
                content: `${classes['propertyAreaContent']} ${classes['noOverflow']}`
              }}
            />
          </Box>
        </Box>
      </Modal>
    </>
  )
}